import { ReactComponent as VisibilityOnIcon } from './visibility_on.svg';

export default VisibilityOnIcon;
